import { useClearable, useFocus, useSearch, useNotify, usePanel, useKeys, useLoading, usePassword, useValidate, useChevron, useAction, } from './hooks';
export * from './input.state';
export function listen() {
    var listeners = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        listeners[_i] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return listeners.forEach(function (l) { return l && l.apply(void 0, args); });
    };
}
export function useInput(state, props) {
    var notify = useNotify(state, props);
    var loading = useLoading(state, props);
    var focus = useFocus(state, props);
    var clear = useClearable(state, props);
    var search = useSearch(state, props);
    var panel = usePanel(state, props);
    var keys = useKeys(state, props);
    var password = usePassword(state, props);
    var validate = useValidate(state, props);
    var chevron = useChevron(state, props);
    var action = useAction(state, props);
    function type() {
        if (password.show && !password.visible) {
            return 'password';
        }
        return props.type;
    }
    return {
        notify: notify,
        loading: loading,
        focus: focus,
        clear: clear,
        search: search,
        panel: panel,
        keys: keys,
        password: password,
        chevron: chevron,
        action: action,
        container: {
            onRootClick: listen(focus.focus, props.onClick),
            clearable: clear.show,
            onClear: clear.clear,
            search: search.show,
            canSearch: search.enable,
            onSearch: search.search,
            panel: panel.show,
            loading: loading.show,
            password: password.show,
            passwordEnable: password.enable,
            passwordVisible: password.visible,
            onPasswordVisible: password.toggle,
            onClickAway: panel.onClickAway,
            chevron: chevron.show,
            chevronEnabled: chevron.enable,
            action: action.show,
            actionEnable: action.enable,
            onAction: listen(props.onAction),
        },
        input: {
            value: '',
            type: type(),
            disabled: props.disabled,
            readOnly: props.readOnly,
            onFocus: listen(focus.onFocus, panel.onFocus, props.onFocus),
            onBlur: listen(validate.onBlur, focus.onBlur, props.onBlur),
            onKeyUp: listen(clear.onKeyUp, keys.onKeyUp, props.onKeyUp),
            onKeyDown: listen(validate.onKeyDown, panel.onKeyDown, keys.onKeyDown, props.onKeyDown),
        }
    };
}
